export const getApiUrl = () =>
  window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().apiURL
    : "http://192.168.3.173/social-service/api";

export const getApplication = () =>
  window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().application
    : "";

export const getToken = () =>
  window.hasOwnProperty("Social") ? window.Social.getApiConfig().token : "";
